import { ca } from '@cian/analytics';

const baseEventParams = {
  category: 'Ad',
  name: 'oldevent',
};

export const trackBannerClick = () => {
  ca('eventSite', {
    ...baseEventParams,
    action: `Click`,
  });
};

export const trackBannerScroll = () => {
  ca('eventSite', {
    ...baseEventParams,
    action: `Scroll`,
  });
};
